


















































import {Component, Prop, Vue, PropSync, Emit, Watch} from 'vue-property-decorator';
import {alert} from 'devextreme/ui/dialog';

import DButton from '@/components/DButton/button.vue';
import DSelectbox from '@/components/DSelectbox/selectbox.vue';
import DSearchBox from '@/components/DSearchBox/search-box.vue';

import DxPopup from 'devextreme-vue/popup';
import { DxValidationGroup } from 'devextreme-vue';

import UserManagerService, { AdUserEntity } from '@/services/data/user_manager';
import AuthService from '@/services/auth_service';


@Component({
  name: 'ADInitAdminPopup',
  components: {
    DxPopup,
    DxValidationGroup,
    DButton,
    DSelectbox,
    DSearchBox,
  }
})

export default class extends Vue {
  @PropSync('visible', {default: false}) popupVisible!: boolean;
  //  Список всех пользователей Active direcory
  @Prop({default: []}) adUsers!: AdUserEntity[];

  // строка для запроса фильтрации пользователей AD по наименованию
  private filterString: any[] = [];
  private adUsersFiltered: AdUserEntity[] = [];

  public service = UserManagerService;
  public authService = AuthService;
  public adUserUID: string | null = null;

  async onShow() {
   this.adUserUID = null;
  }

  onClose() {
    this.popupVisible = false;
  }

  get usersDS() {
    if (this.adUsersFiltered.length && this.filterString.length) {
      return  this.adUsersFiltered;
    }
    return this.adUsers;
  }

  @Watch('filterString')
  onFilterStringChange(filter: any[]) {
    if (filter.length == 3 && filter[2]) {
      // запрос на фильтрацию данных пользователей AD
      AuthService.initAdminCheck(filter[2]).then(initAdminResp => {
        if (initAdminResp.length) {
          this.adUsersFiltered = [ ...initAdminResp ];
        }
      });
    }  else {
      this.adUsersFiltered = [];
    }
  }

  @Emit()
  onSave() {
    return this.adUserUID;
  }

  async onOk(e: any) {
    const vg = (this.$refs['adminUserInitForm'] as any).instance;
    const result = vg.validate();
    if (result.isValid) {
      try {
        this.onSave();
        this.onClose();

      } catch (e) {
        console.log(e)
      }
    } else {
      const errors = result.brokenRules.map((item: any) => item.message);
      if (errors.length > 0) {
        await alert(errors.join('<br>\n'), 'Ошибка');
      }
    }
  }

}
